import React from "react";
import Layout from "../layouts";
import AccountScreen from "../screens/Accounts/Accounts";

const Account = () => {
  return (
    <Layout>
      <AccountScreen />
    </Layout>
  );
};
export default Account;
